import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserSettings } from '@/types';

const defaultSettings: UserSettings = {
  theme: 'auto',
  language: 'zh',
  notifications: {
    transactions: true,
    priceAlerts: true,
    systemUpdates: true,
  },
  autoConnect: true,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState: defaultSettings,
  reducers: {
    setTheme: (state, action: PayloadAction<UserSettings['theme']>) => {
      state.theme = action.payload;
    },
    setLanguage: (state, action: PayloadAction<UserSettings['language']>) => {
      state.language = action.payload;
    },
    setNotificationSettings: (state, action: PayloadAction<Partial<UserSettings['notifications']>>) => {
      state.notifications = { ...state.notifications, ...action.payload };
    },
    setAutoConnect: (state, action: PayloadAction<boolean>) => {
      state.autoConnect = action.payload;
    },
    resetSettings: () => defaultSettings,
  },
});

export const {
  setTheme,
  setLanguage,
  setNotificationSettings,
  setAutoConnect,
  resetSettings,
} = settingsSlice.actions;

export default settingsSlice.reducer; 